import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Badge } from 'react-bootstrap';
import ItemModelMpm from '../IC/ItemModelMpm';



export default function DGLTH_pdc_distinta({ item, entity = null }) {

    const [show, setShow] = useState(false);

    useEffect(() => {

    }, []);


    function handleClose() {
        setShow(false)
    }



    return (
        <>
            <Button variant='outline-success' size='sm' onClick={() => { setShow(true) }}>Distinta base</Button>

            {show === true ? (
                <Modal show={show} onHide={handleClose} scrollable size={'xl'}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Distinta <span className='text-primary'>{item && item.item_code}</span> x {item.quantity}<br />
                            <span className='small text-muted'>{item && item.name}</span>
                            <p className='small text-muted'>Quantità precedentemente impegnata: {item.previousQta ? item.previousQta : 0}</p>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {item && (
                            <div id='mpm-tree-container'>
                                <ItemModelMpm item={{ id: item.id_item }} isPicking={item.picking} quantity={item.quantity} showDetails={true} previousQta={item.previousQta} />
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Chiudi
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : (
                <></>
            )}



        </>
    )
};